import styled from '@emotion/styled';
import Dialog from '@/components/Dialog';

const UnsavedChangesDialogTitle = styled(Dialog.Title)({
  display: 'flex',
  alignItems: 'center',
  '.MuiIconButton-root': {
    marginLeft: 'auto',
    marginTop: -7.5,
    marginBottom: -7.5,
  },
});

export default UnsavedChangesDialogTitle;
